import { serverRouteConfig } from "@server/server-route-config"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/api/oidc/authorize")(
  serverRouteConfig({
    server: {
      handlers: {
        GET: async ({ request }) => {
          const { handleShortLinksOidcAuthorize } = await import(
            "@api/features/short-links-sso/shortLinksOidcHandlers"
          )
          return handleShortLinksOidcAuthorize(request)
        },
      },
    },
  })
)
